import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import apiHelpers from '../../../utils/apiHelpers';

const SelectStore = props => {
  const [storeOptions, setStoreOptions] = useState([
    { value: null, label: 'Todos' },
  ]);

  useEffect(() => {
    apiHelpers.getStores().then(res => {
      const stores = res.data || [];
      const options = [
        { value: null, label: 'Todos' },
        ...stores.map(store => ({ value: store.store, label: store.store })),
      ];
      setStoreOptions(options);
    });
  }, []);

  const onChangeWrapper = selectedOptions => {
    let event = { target: {} };
    event.target.name = props.name ? props.name : 'select-nameless';

    if (selectedOptions && selectedOptions.length > 0) {
      const hasAllOption = selectedOptions.some(
        option => option.value === null,
      );
      const hasSpecificStores = selectedOptions.some(
        option => option.value !== null,
      );

      if (hasAllOption && hasSpecificStores) {
        const currentValue = props.value;
        const wasAllSelected =
          currentValue === null || currentValue === undefined;

        if (wasAllSelected) {
          // User had "Todos" selected and added a specific store — keep only specifics
          const specificStores = selectedOptions.filter(
            option => option.value !== null,
          );
          event.target.value = specificStores.map(option => option.value);
        } else {
          // User had specific stores and selected "Todos" — switch to "Todos"
          event.target.value = null;
        }
      } else if (hasAllOption) {
        event.target.value = null;
      } else {
        event.target.value = selectedOptions.map(option => option.value);
      }
    } else {
      event.target.value = [];
    }

    event.target.type = 'react-select-multi';
    props.onChange(event);
  };

  let value = props.value;

  if (value === null || value === undefined) {
    value = [];
  } else if (Array.isArray(value)) {
    value = storeOptions.filter(option => value.includes(option.value));
  } else {
    value = [storeOptions.find(option => option.value === value)].filter(
      Boolean,
    );
  }

  return (
    <Select
      className={props.selectClassName}
      name={props.name}
      onChange={onChangeWrapper.bind(this)}
      value={value || []}
      required={props.required}
      options={storeOptions}
      isMulti={true}
      isClearable={false}
      placeholder={props.placeholder}
      menuPortalTarget={document.body}
      disabled={props.disabled}
      styles={{
        control: provided => ({
          ...provided,
          minHeight: '40px',
          padding: '0 0px',
          borderRadius: '0.375rem',
        }),
        dropdownIndicator: provided => ({
          ...provided,
          padding: '0 8px',
        }),
        clearIndicator: provided => ({
          ...provided,
          padding: '0 8px',
        }),
        input: provided => ({
          ...provided,
          padding: '0',
          margin: '0',
        }),
        multiValue: provided => ({
          ...provided,
          backgroundColor: '#e2e8f0',
          borderRadius: '0.25rem',
        }),
        multiValueLabel: provided => ({
          ...provided,
          color: '#1e293b',
        }),
        multiValueRemove: provided => ({
          ...provided,
          color: '#64748b',
          ':hover': {
            backgroundColor: '#cbd5e1',
            color: '#1e293b',
          },
        }),
      }}
    />
  );
};

export default SelectStore;
